if (window.sentryConfig.url && window.sentryConfig.url !== 'ENV_SENTRY_URL') {
  window.sentryConfig.params.release =
    window.sentryConfig.release !== 'latest' ? window.sentryConfig.release : window.sentryConfig.gitHash;
  Raven.config(window.sentryConfig.url, window.sentryConfig.params)
    .addPlugin(window.RavenAngularPlugin, window.angular).install();
} else {
  // Create no-op angular module for ngRaven
  angular.module('ngRaven', []);
}

const loadApp = require('./loadapp.common.js');

const htmlContext = require.context('../static/app', true, /\.html$/);

loadApp('/build/build.js', 'app', 'app.MainController', htmlContext);



//////////////////
// WEBPACK FOOTER
// /app/suissealpine/webpack/loadapp.js
// module id = 391
// module chunks = 0